/**
 * Module dependencies.
 */

import isNil from 'lodash/isNil';
import pickBy from 'lodash/pickBy';
import { axiosInstance, getApiEndpoint } from 'src/core/utils/requests';
import { User } from 'src/types/user';

/**
 * Export `SignUpData` type.
 */

export type SignUpData = {
  email: User['email'];
  isFamiliarCompany: boolean;
  nif: User['nif'];
  password: string;
};

/**
 * `CompleteSignUpData` type.
 */

export type CompleteSignUpData = {
  proofFile: any;
} & Omit<User, 'email' | 'id' | 'isFamiliarCompany' | 'nif' | 'status'>;

/**
 * Export `signUp` request.
 */

export async function signUp(data: SignUpData) {
  const response = await axiosInstance.post<Record<'data', { token: string }>>(getApiEndpoint('signUp'), data);

  return response?.data;
}

/**
 * Export `completeSignUp` request.
 */

export async function completeSignUp(data: CompleteSignUpData) {
  const formData = new FormData();

  Object.entries(pickBy(data, elem => !isNil(elem))).forEach(([key, value]) => {
    if (key === 'invoiceVolume') {
      Object.entries(data.invoiceVolume ?? {}).forEach(([year, volume]) => {
        formData.append(`invoiceVolume[${year}][collaborators]`, volume.collaborators);

        formData.append(`invoiceVolume[${year}][invoice]`, volume.invoice);
      });

      return;
    }

    if (key === 'proofFile') {
      formData.append('proofFile', value?.[0]);

      return;
    }

    formData.append(key, value);
  });

  const response = await axiosInstance.post<Record<'data', { token: string }>>(
    getApiEndpoint('completeSignUp'),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response?.data;
}
